import { render, staticRenderFns } from "./BalanceBanner.vue?vue&type=template&id=32d5ea46&scoped=true"
import script from "./BalanceBanner.vue?vue&type=script&lang=js"
export * from "./BalanceBanner.vue?vue&type=script&lang=js"
import style0 from "./BalanceBanner.vue?vue&type=style&index=0&id=32d5ea46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d5ea46",
  null
  
)

export default component.exports